import React from 'react';

import styles from './CompliantFooterLinksDE.module.css';

function CompliantFooterLinksDE() {
    return (
        <div className={styles.grid}>
            <span className={styles.info}>Weiterführende Informationen: </span>
            <a
                href="https://www.iwoca.de/allgemeine_geschaeftsbedingungen/"
                className={styles.link}>
                AGBs
            </a>
            <div className={styles.divider} />
            <a
                href="https://www.iwoca.de/datenschutzhinweis/"
                className={styles.link}>
                Datenschutz
            </a>
            <div className={styles.divider} />
            <a
                href="https://www.iwoca.de/schufa_creditreform_hinweise/"
                className={styles.link}>
                Schufa & Crefo
            </a>
            <div className={styles.divider} />
            <a href="https://www.iwoca.de/" className={styles.link}>
                iwoca.de
            </a>
        </div>
    );
}

export default CompliantFooterLinksDE;
